module.exports = __webpack_public_path__ + "src/client/assets/img/logo-white@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/img/logo-white@2x.png
// module id = 1205
// module chunks = 0